import { Box, Chip, Stack } from '@mui/material';
import { toneColor, type Tone } from './tone';

/** A small coloured pill: "In Transit", "Draft", "Delayed" */
export function StatusChip({ label, tone }: { label: string; tone: Tone }) {
  return (
    <Chip
      size="small"
      label={label}
      sx={{
        bgcolor: `color-mix(in srgb, ${toneColor(tone)} 14%, transparent)`,
        color: toneColor(tone),
        fontWeight: 600,
      }}
    />
  );
}

/** A small coloured dot (status lights) */
export function StatusDot({ tone }: { tone: Tone }) {
  return (
    <Box
      component="span"
      sx={{ display: 'inline-block', width: 9, height: 9, borderRadius: '50%', bgcolor: toneColor(tone) }}
    />
  );
}

/** A coloured dot followed by a word: "● High", "● On time" */
export function DotLabel({ label, tone }: { label: string; tone: Tone }) {
  return (
    <Stack direction="row" spacing={0.75} sx={{ alignItems: 'center' }}>
      <StatusDot tone={tone} />
      <span>{label}</span>
    </Stack>
  );
}
